import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=59a610ed&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=59a610ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a610ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a610ed')) {
      api.createRecord('59a610ed', component.options)
    } else {
      api.reload('59a610ed', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=59a610ed&scoped=true", function () {
      api.rerender('59a610ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/spellGroupList/detail.vue"
export default component.exports